import { SpeedInsights } from '@vercel/speed-insights/react';
import { Analytics } from '@vercel/analytics/react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@/contexts/ThemeContext';
import HomePage from '@/pages/HomePage';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className='min-h-screen bg-background text-foreground transition-colors duration-300'>
          <Routes>
            <Route path='/' element={<HomePage />} />
          </Routes>
        </div>
      </Router>
      <SpeedInsights />
      <Analytics />
    </ThemeProvider>
  );
}

export default App;
